import { type z } from 'zod';
import { object as __eliadmin_zod_0, string as __eliadmin_zod_1, boolean as __eliadmin_zod_2 } from 'zod';
import { ensureZodDefaults as __eliadmin_zod_defaults } from '@eliadmin/core/src/build/zod-defaults';
__eliadmin_zod_defaults();

import { RESET_COPY } from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-copy';
import { meetsRequiredPasswordRules } from '@eliadmin/core/src/components/dlz/forms/password-rules';
import type { FormValidationMessages } from '@eliadmin/core/src/hooks/use-form-validation-messages';

/**
 * Body of `changePassword` (core `changePasswordSchema`) plus `logout_other_devices`. The new
 * password has to meet the rules listed under it (`PASSWORD_RULES`) and differ from the current one,
 * as the core form checks.
 */
export const passwordFormSchema = (VM: FormValidationMessages, sameAsCurrentMessage: string) =>
  __eliadmin_zod_0({
      password_old: __eliadmin_zod_1().min(1, VM.CANT_BE_EMPTY_VALIDATION_MESSAGE()),
      password: __eliadmin_zod_1(),
      password_confirmation: __eliadmin_zod_1(),
      logout_other_devices: __eliadmin_zod_2(),
    })
    .superRefine((values, ctx) => {
      const issue = (path: 'password' | 'password_confirmation', message: string) =>
        ctx.addIssue({ code: 'custom', path: [path], message });

      if (!values.password) issue('password', VM.CANT_BE_EMPTY_VALIDATION_MESSAGE());
      else if (!meetsRequiredPasswordRules(values.password)) {
        issue('password', RESET_COPY.passwordRules);
      } else if (values.password === values.password_old) {
        issue('password', sameAsCurrentMessage);
      }

      if (!values.password_confirmation) {
        issue('password_confirmation', VM.CANT_BE_EMPTY_VALIDATION_MESSAGE());
      } else if (values.password_confirmation !== values.password) {
        issue('password_confirmation', VM.PASSWORD_CONFIRMATION_DONT_MATCH_VALIDATION_MESSAGE());
      }
    });

export type PasswordFormValues = z.infer<ReturnType<typeof passwordFormSchema>>;
